/**
 * Explorer's idle clock.
 *
 * One clock per app, built once at module load. The cookie is scoped to
 * samsurveyor.com wherever that is allowed, so Explorer shares one clock with
 * Console, Designer and Channels. Working in any one of them keeps the others
 * signed in.
 *
 * Explorer has no draft store. Everything it shows is already saved: responses,
 * deployments, segment definitions. There is no in-memory work here that a
 * sign-out could destroy, so there is nothing to rescue at the 28-minute
 * warning. If a screen is ever added that holds unsaved text, it should
 * register a saver the way Designer's App does.
 */

// Deep paths on purpose. The `@cloudsam/ui` index pulls in AppShell, Panel,
// Button and the rest, so anything importing this file would drag the whole
// component set into its import graph. These modules are plain JavaScript with
// no React in them.
import { createIdleClock } from '@cloudsam/ui/dist/idle/idleClock';
import { sessionCookieDomain } from '@cloudsam/ui/dist/idle/cookieDomain';
import { createHeartbeatSender } from '@cloudsam/ui/dist/idle/heartbeat';
import { getDbamBase } from './dbamBase';

/** How long a person may be idle before the session ends. */
export const IDLE_LOCK_MINUTES = 30;

export const idleClock = createIdleClock({
    cookiePrefix: 'sam',
    cookieDomain: sessionCookieDomain(),
    // Tells sam-dbam a person is here, so it can enforce the same 30 minutes on
    // its own. The browser timer only runs while a browser is running; close a
    // laptop at minute five and nothing revokes anything.
    onHeartbeat: createHeartbeatSender({ url: () => `${getDbamBase()}/dbam/v1/me/heartbeat` }),
});

export default idleClock;
